export interface ManHoursArray {
  id: number;
  employeeCode: number;
  employeeName: string;
  projectName: string;
  month: string;
  totalManHours: string;
}

export type ManHoursGetResponse = {
  items: ManHoursArray[];
  page: number;
  totalPages: number;
};

export const EmptyManHoursGetResponse: ManHoursGetResponse = {
  items: [
    {
      id: 0,
      employeeCode: 0,
      employeeName: '',
      projectName: '',
      month: '',
      totalManHours: '',
    },
  ],
  page: 1,
  totalPages: 0,
};
